/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/banner_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdBannerTemplatesId } from "./constants";
import type { EngagementAppGroupIdBannerTemplatesIdResult } from "./types";
import { isEngagementAppGroupIdBannerTemplatesIdResult } from "./validators";

export const getEngagementAppGroupIdBannerTemplatesId = reactQueryFetcherAdapter(
  engagementAppGroupIdBannerTemplatesId,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<EngagementAppGroupIdBannerTemplatesIdResult> => {
    return fetch(`/engagement/${appGroupId}/banner_templates/${id}`, "GET", {}, { signal });
  },
  isEngagementAppGroupIdBannerTemplatesIdResult
);
